<template>
  <div class="home">
    <div class="mb-10">
      <h1>{{ settingsStore.quickShareTitle }}</h1>
    </div>
    <div>
      <ul>
        <li v-for="progressKey in Object.keys(downloadProgress)" :key="progressKey">
          {{ progressKey }}:
          {{
            downloadProgress[progressKey]
              ? downloadProgress[progressKey] === -1
                ? "Forbereder download..."
                : downloadProgress[progressKey] + "%"
              : "Færdig"
          }}
        </li>
      </ul>
    </div>

    <DocumentTable
      :driveItems="documentStore.quickShareDocuments"
      :showIcon="true"
      :showName="true"
      :showType="true"
      :showSize="true"
      :showCreatedDate="true"
      :showSharedWith="false"
      :showModifiedDate="true"
      :showModifiedBy="true"
      :isClicable="true"
      :isSelectable="false"
      @driveItemClick="onDriveItemClick"
    />

    <div class="mt-4 text-right">
      <button
        class="button font-semibold text-primary-core opacity-70 mt-4 p-0 hover:underline"
        @click="downloadDocumentsAsZip"
      >
        <font-awesome-icon :icon="['far', 'download']" class="mr-3" />{{ $t("Files.DownloadAllAsZip") }}
      </button>
    </div>
  </div>
</template>

<script>
import DocumentTable from "@/components/Documents/Table/DocumentTable";
import { useSettingsStore } from "@/stores/settings";
import { useDocumentStore } from "@/stores/documents";

export default {
  name: "HomeView",

  props: {
    shareId: {
      type: String,
      required: true
    }
  },

  setup() {
    return {
      settingsStore: useSettingsStore(),
      documentStore: useDocumentStore()
    };
  },

  async mounted() {
    try {
      await this.documentStore.loadQuickShareDocuments();
      // eslint-disable-next-line no-empty
    } catch {}
  },

  computed: {
    downloadProgress() {
      return this.documentStore.downloadProgress;
    }
  },

  methods: {
    async onDriveItemClick(driveItem) {
      await this.downloadDocument(driveItem.itemId, driveItem.name);
    },

    async downloadDocument(itemId, itemName) {
      try {
        const documentContentsAsBytes = await this.documentStore.downloadQuickShareDocument(itemId);

        const url = window.URL.createObjectURL(new Blob([documentContentsAsBytes]));
        const element = document.createElement("a");
        element.href = url;
        element.setAttribute("download", itemName);
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      } catch (e) {
        //this.$skboMessage.errorMessage(this.$t("Documents.Errors.ErrorDuringDownload"));
      }
    },

    async downloadDocumentsAsZip() {
      try {
        const zipContentsAsBytes = await this.documentStore.downloadQuickShareDocumentsAsZip();

        const url = window.URL.createObjectURL(new Blob([zipContentsAsBytes]));
        const element = document.createElement("a");
        element.href = url;
        element.setAttribute("download", `${this.settingsStore.quickShareTitle}.zip`);
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      } catch (e) {
        //this.$skboMessage.errorMessage(this.$t("Documents.Errors.ErrorDuringDownload"));
      }
    }
  },

  components: {
    DocumentTable
  }
};
</script>
